import { render, staticRenderFns } from "./QuestionTable.vue?vue&type=template&id=00530b9b&scoped=true"
import script from "./QuestionTable.ts?vue&type=script&lang=ts&external"
export * from "./QuestionTable.ts?vue&type=script&lang=ts&external"
import style0 from "./QuestionTable.vue?vue&type=style&index=0&id=00530b9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00530b9b",
  null
  
)

export default component.exports